<script setup lang="ts">
import {ref} from 'vue';

const props = defineProps<{
  headTreePath: string;
}>();

type FlipEventData = {
  headTreePath: string;
  isFlipped: boolean;
};

const flipped = ref<boolean>(false);

function handleClick() {
  flipped.value = !flipped.value;
  document.dispatchEvent(new CustomEvent<FlipEventData>('allspice-pcb-flip', {
    bubbles: true,
    detail: {
      headTreePath: props.headTreePath,
      isFlipped: flipped.value,
    },
  }));
}
</script>

<template>
  <div class="allspice-flip-toggle">
    <button
      class="ui mini basic button"
      @click="handleClick"
    >
      {{ flipped ? 'View Top' : 'View Bottom' }}
    </button>
  </div>
</template>
